// extracted by mini-css-extract-plugin
export var standaloneTable = "_fw-0";
export var standaloneTableWithBodyFill = "_fw-1";
export var withExtraHeader = "_fw-2";